import {getStatisticsUserElect,getStatisticsUserMoney,getStatisticsEntElect} from "@/common/api";


/**
 * 普通会员按电量
 * @returns 
 */
const getMemberDlData = ()=>{
  return new Promise(async(resolve) => {
    let ret = await getStatisticsUserElect({});

    resolve(chartTemplate(ret))
    
  })
}
/**
 * 普通会员按金额
 * @returns 
 */
const getMemberMoneyData = ()=>{
  return new Promise(async(resolve) => {
    let ret = await getStatisticsUserMoney({});

    resolve(chartTemplate(ret))
  })
  
}

/**
 * 企业管理员 - 个人(自己)
 * @returns 
 */
const getEntPersonalData = ()=>{
  return new Promise(async(resolve) => {
    let ret = await getStatisticsEntElect({dataType: 1});

    resolve(chartTemplate(ret))
  })
  
  
}

/**
 * 企业管理员 / 企业会员 - 统付
 * @returns 
 */
const getEntAdminPayData = ()=>{
  return new Promise(async(resolve) => {
    let ret = await getStatisticsEntElect({dataType: 3});

    resolve(chartTemplate(ret))
  })
}

/**
 * 企业管理员 / 企业会员 - 个付
 * @returns 
 */
const getEntAdminPersonalPayData = ()=>{
  return new Promise(async(resolve) => {
    let ret = await getStatisticsEntElect({dataType: 2});

    resolve(chartTemplate(ret))
  })
  
}

/**
 * 企业支付/企业个人支付
 * @returns 
 */
const getEntPayData = ()=>{
  // 和管理员 个人 是一样的
  return getEntPersonalData;
  
}
/**
 * 模板数据
 * @param {*} data
 * @returns 
 */
const chartTemplate = (ret)=>{
  let json = {
    nameArr: [],
    valueArr: [],
  }
  if(ret.status == 0 && ret.data){
    ret.data.map(item=>{
      json.nameArr.push(item.dayTime);
      json.valueArr.push(item.dataValue);
    })
  }
  
  return json;
}


export default{
  getMemberDlData,
  getMemberMoneyData,
  getEntPersonalData,
  getEntAdminPayData,
  getEntAdminPersonalPayData,
  getEntPayData,
}